import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { ContextItem, RequirementContextType } from "../../../../types";
import { WSPillProps } from "@wingspanhq/fe-component-library";
import { RequirementStatus } from "@wingspanhq/payments/dist/interfaces/requirement";
import { selectorIsSharedFileNotNoneContext } from "../../../../selectors/selectorIsSharedFileNotNoneContext";
import {
  ISharedFileRequestResponse,
  SharedFileRequestStatus
} from "@wingspanhq/shared-files/dist/lib/interfaces";
import { extendRequirementStatusSecondaryText } from "../../../../helpers/extendRequirementStatusSecondaryText";
import { extendRequirementStatusPill } from "../../../../helpers/extendRequirementStatusPill";

export const getSharedFileRequirementStatus = (
  requirement: IRequirementResponse,
  contextItem: ContextItem,
  sharedFile: ISharedFileRequestResponse | undefined,
  contextType: RequirementContextType
): { pill: WSPillProps; secondaryText?: string } => {
  let pill: WSPillProps;

  let secondaryText: string | undefined;

  if (requirement.status === RequirementStatus.Complete) {
    pill = {
      theme: "success",
      text: "Complete",
      icon: true
    };

    secondaryText = undefined;
  } else if (
    selectorIsSharedFileNotNoneContext(sharedFile?.contextType) &&
    sharedFile?.status === SharedFileRequestStatus.Failed
  ) {
    pill = {
      theme: "error",
      text: "Failed",
      icon: true
    };
    secondaryText = "Submitted with failed validations";
  } else if (
    selectorIsSharedFileNotNoneContext(sharedFile?.contextType) &&
    sharedFile?.status === SharedFileRequestStatus.Processing
  ) {
    pill = {
      theme: "neutral",
      text: "Processing",
      icon: "time"
    };
    secondaryText = undefined;
  } else {
    if (contextType === RequirementContextType.Payee) {
      pill = {
        theme: "neutral",
        text: "Awaiting contractor",
        icon: "time"
      };
      secondaryText = "Awaiting contractor completion";
    } else {
      pill = {
        theme: "warning",
        text: "Action required",
        icon: true
      };
      secondaryText = "Awaiting your completion";
    }
  }

  return {
    pill: extendRequirementStatusPill(requirement, contextType, pill),
    secondaryText: extendRequirementStatusSecondaryText(
      requirement,
      contextType,
      secondaryText
    )
  };
};
